import { BasicContent } from "./BasicContent";
import { BasicHeader } from "./BasicHeader";
import { BasicLayout as InternalLayout } from "./BasicLayout";
import { BasicSider } from "./BasicSider";
var BasicLayout = InternalLayout;
BasicLayout.BasicSider = BasicSider;
BasicLayout.BasicContent = BasicContent;
BasicLayout.BasicHeader = BasicHeader;
export { findMenuNode } from "./BasicSider";
export default BasicLayout;